import { useComposerEditorStore } from "#features/conversations/stores/useComposerEditorStore.ts";
import { useSubscriptionTier } from "#hooks/useSubscriptionTier.ts";
import { useCallback, useEffect } from "react";

export const useFilePasteFromClipboard = (handleFileSelected: (selectedFiles: File[]) => void, targetRef: React.RefObject<HTMLElement | null>) => {
    const { isFreemium } = useSubscriptionTier();
    const isEditorUnavailable = useComposerEditorStore(state => state.isEditorUnavailable);

    const handlePaste = useCallback((event: ClipboardEvent) => {
        if (!event.clipboardData || isFreemium || isEditorUnavailable) {return;}

        const hasText = event.clipboardData.types.includes("text/plain");
        const hasFiles = event.clipboardData.files.length > 0;

        // Only process files if no text is present
        if (hasFiles && !hasText) {
            const files = Array.from(event.clipboardData.files);
            handleFileSelected(files);
        }
    }, [handleFileSelected, isEditorUnavailable, isFreemium]);

    useEffect(() => {
        const target = targetRef.current;

        if (target) {
            target.addEventListener("paste", handlePaste);
        }

        return () => {
            if (target) {
                target.removeEventListener("paste", handlePaste);
            }
        };
    }, [handlePaste, targetRef]);
};
